import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import restExample3 from './assets/images/rest-example3.png';





const JavaScriptLesson65 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3>De-structuring Assignment</h3>
        <p><strong>Destructuring</strong> is the process of unpacking values from an array or properties from objects into distinct variables.</p>
        <img class="img-fluid mb-4" src={restExample3} />
    
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson65